/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Titles_Selectorganization1Inputs */

const en_settings_titles_selectorganization1 = /** @type {(inputs: Settings_Titles_Selectorganization1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select your organization`)
};

/**
* | output |
* | --- |
* | "Select your organization" |
*
* @param {Settings_Titles_Selectorganization1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_titles_selectorganization1 = /** @type {((inputs?: Settings_Titles_Selectorganization1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Titles_Selectorganization1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_titles_selectorganization1(inputs)
});
export { settings_titles_selectorganization1 as "settings_titles_selectOrganization" }